import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import Setup from './pages/Setup';
import Manage from './pages/Manage';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Usage from './pages/Usage';
import Login from './pages/Login';
import LoginComplete from './pages/LoginComplete';
import AuthCallback from './pages/AuthCallback';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Landing />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="/manage" element={<Manage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/usage" element={<Usage />} />
        {/* OAuth + magic-link flow pages — used by both MCP clients
            (ChatGPT/Claude) and our own /manage sign-in. */}
        <Route path="/login" element={<Login />} />
        <Route path="/login/complete" element={<LoginComplete />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Route>
    </Routes>
  );
}
